import { createContext } from "react"
import PayoffChart from "./payoffChart/payoffChart"

export type PayoffGraphContextType = {
    payoffChart?: PayoffChart
    updateSliderElements: (elements: Record<string, HTMLDivElement>) => void
    setPayoffChart:  (chart: PayoffChart) => void
    setChartAnchorContainer: (container: HTMLDivElement | null) => void
}


export const PayoffGraphContext = createContext<PayoffGraphContextType>({
    updateSliderElements() {},
    setPayoffChart(chart) {},
    setChartAnchorContainer() {},
})